module.exports = " <div class=asset-uploader> <input type=file multiple=multiple class=hide v-el:native-file-field> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/assets/Uploader.vue
// module id = 285
// module chunks = 0